module.exports = __webpack_public_path__ + "static/img/skm4.04578f66.png";